export const required = ({ message } = {}) => (name, value) => {
    if (typeof value === 'number' && value === 0) {
        return null;
    }
    if (!value) {
        return message || 'This field is required';
    }
    return null;
};

export const maxLength = ({ maxLength }) => (name, value) => {
    if (value?.length > maxLength) {
        return `Max ${maxLength} tegn`;
    }
    return null;
};

export const number = ({ message }) => (name, value) => {
    if (!/^\d+$/.test(value)) {
        return message || `Field can contain only numbers`;
    }
    return null;
};

export const maxValue = ({ maxValue, message }) => (name, value) => {
    if (value > maxValue) {
        return message || `Max number is: ${maxValue}`;
    }
    return null;
};

export const minValue = ({ minValue, message }) => (name, value) => {
    if (value < minValue) {
        return message || `Min value is ${minValue}`;
    }
};

export const regexp = ({ regex, message }) => (name, value) => {
    if (regex.test(value)) {
        return message || `Invalid ${name} format`;
    }
    return null;
};

export function validate(form, rules) {
    const errors = Object.entries(rules).map(([field, rule]) => {
        const value = form[field];

        if (Array.isArray(rule)) {
            const error =
                rule
                    .map((validator) => validator(field, value, form))
                    .find((message) => Boolean(message)) || null;
            return [field, error];
        } else {
            return [field, rule(field, value, form)];
        }
    });

    return Object.fromEntries(errors);
}
